uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

#pragma glslify: quadraticInOut = require(glsl-easings/quadratic-in-out)

float circle(vec2 p, vec2 offset) {
    vec2 circleP = p + offset;
    circleP.x *= 0.8;
    float circle = 1.0 - clamp(length(circleP), 0.0, 200.0) / 200.0;
    circle = quadraticInOut(circle);
    return circle;
}

vec4 blendNormal(vec4 base, vec4 blend) {
    // Calculate the alpha of the output color
    float outAlpha = blend.a + base.a * (1.0 - blend.a);

    // Blend the colors
    vec3 outColor = (blend.rgb * blend.a + base.rgb * base.a * (1.0 - blend.a)) / outAlpha;

    return vec4(outColor, outAlpha);
}

void main() {
    vec2 uv = vUv - 0.5;
    vec2 p = uv * resolution;

    float circleTop = circle(p, vec2(0.0, -80.0));
    float circleBottom = circle(p, vec2(0.0, 80.0));

    vec4 background = vec4(1.0);
    vec3 topColor = vec3(0.96, 0.96, 0.19);
    vec4 circleTopColor = vec4(topColor, circleTop );
    vec3 bottomColor = vec3(0.93, 0.2, 0.75);
    vec4 circleBottomColor = vec4(bottomColor, circleBottom);

    vec4 outColor = blendNormal(background, circleBottomColor);
    outColor = blendNormal(outColor, circleTopColor);

    gl_FragColor = outColor;
}